import { doDoorKnock, doSmsSound, doTransition, doWaitImageByTime, getInstaImage } from './../helpers/helpers';
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { Insta } from '../../src/components/insta/InstaClass';
import { alex } from '../characters/Alex';
import { images, uiImages } from './images';
import { empty } from '../characters/empty';
import Game from '../../src/shell/Game';
import { ClubHome } from './V4';
import { rick } from '../characters/Rick';
import { stranger } from '../characters/Stranger';
import { ClubEventWithoutJoeInsideGoToVanessa, ClubEventWithoutJoeInsideVanessaDancing3 } from './V4_BarWithoutJoey';
import UI from '../../src/shell/UI';
import { getInstaData } from '../helpers/InstaPostsHelpers';
import { Phone } from '../../src/components/phoneUI/PhoneClass';
import { annImages, annProfilesPic } from '../helpers/annInstaImages';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';
import SoundClass from '../../src/shell/Sound';
import { sounds } from './sounds';


export const ClubEventJoe = async (): Promise<any> => {

    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });

    doSmsSound();


    await Phone.showMessagesUI({ name: joe.name }, async () => {
        Phone.setMessage({ character: joe.character, text: `Yo ${mc.name}!`, options: { wait: false } });
        Phone.setMessage({ character: joe.character, text: `I've just heard that the bar is throwing a party today.` });
        Phone.setMessage({ character: joe.character, text: `The timing couldn't be any better since my birthday is at midnight.` });
        Phone.setMessage({ character: joe.character, text: `You wanna check it out?` });

        if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
            Phone.setMessage({ character: mc.character, text: `Joey, are you sure it's a good idea?` });
            Phone.setMessage({ character: mc.character, text: `The bartender that Vanessa did something with might be there...` });

            Phone.setMessage({ character: joe.character, text: `I am not going to change my plans because of some jerk.` });
            Phone.setMessage({ character: joe.character, text: `Plus, I have a plan.` });
            Phone.setMessage({ character: mc.character, text: `What?` });
            Phone.setMessage({ character: joe.character, text: `It's not for texts, I'll explain once we get there.` });


            Phone.setMessage({ character: joe.character, text: `So are you coming or not?` });
        } else {

        }

        Phone.setMessage({ character: mc.character, text: `Of course, I'll come, who else is coming?` });

        Phone.setMessage({ character: joe.character, text: `Vanessa should arrive at my place any minute now. I believe she told Ann to come already.` });



        if (mc.properties.annStatus === "natural" && Question.globalAnswers.afterTODEnteredNaked) {
            Phone.setMessage({ character: mc.character, text: `I haven't had the chance to talk to her since she ran away this morning...` });
            Phone.setMessage({ character: joe.character, text: `Don't worry, you will have plenty of time to apologize today LOL.` });
        }
        Phone.setMessage({ character: joe.character, text: `I gotta go, cya there.` });
        Phone.closeMessagesUI();
    });




    mc.think(`I need to get ready and head to the bar.`);
    if (mc.properties.annStatus === "natural") {
        ImageClass.setImage(images.v1.RoomAlone_2);
        doDoorKnock();
        mc.think(`Someone is knocking at the front door.`);
        ImageClass.setImage(images.v4.VanessaDoor);
        mc.think(`I am not expecting anyone...`);
        ImageClass.setImage(images.v4.VanessaDoor1);
        mc.think(`Vanessa? What is she doing here?`);
        mc.talk(`Hey Vanessa!`);
        if (Question.globalAnswers.v2VanessaDressLikedTheMost === "white") {
            mc.talk(`Why aren't you wearing the white dress?`);
            vanessa.talk(`Joe didn't like it.`);
        } else if (Question.globalAnswers.v2VanessaDressLikedTheMost === "black") {
            mc.talk(`Why aren't you wearing the black dress?`);
            vanessa.talk(`Joe didn't like it.`);
        } else {
            mc.talk(`I see that you picked my dress.`);
            if (mc.properties.vanessaRemovedPanties) {

                mc.talk(`But I told you it's better without the panties.`);
                vanessa.talk(`Joe wanted them on.`);
            }
        }
        vanessa.talk(`Listen, I don't have much time.`);
        vanessa.talk(`I just came over to talk to you about something.`);
        mc.talk(`Alright, do you want to come in?`);
        vanessa.talk(`No, it's going to be short.`);


        mc.talk(`What is it?`);
        vanessa.talk(`I need a favor.`);
        if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "blackmailHer") {
            mc.talk(`Favor? After what almost happened in the coffee shop earlier?`);
            vanessa.talk(`No harm was done. Right?`);
            mc.talk(`Yeah...`);
        } else {

            mc.talk(`What favor?`);
        }
        vanessa.talk(`Let me get to the point.`);
        vanessa.talk(`So Ann and I were talking the past few days.`);
        vanessa.talk(`She said that she wants to change her lifestyle a bit, not something drastic.`);
        vanessa.talk(`I tried explaining to her what she needs to do, but I think words aren't going to be enough.`);
        vanessa.talk(`So I came up with a plan.`);
        vanessa.talk(`My friend gave me a magic pill. I am going to give it to Ann, and it's going to boost her confidence.`);
        vanessa.talk(`And it's not like she is going to start a massive orgy all of the sudden.`);
        vanessa.talk(`It will just help her say and do things she really wants to do.`);
        mc.talk(`Are you talking about drugs?`);
        vanessa.talk(`You can call it what you want.`);
        vanessa.talk(`I'll only do it as last resort. I'll try to convince her, but if I see that's it's not working. I'm going to put plan B to action.`);
        mc.talk(`Why are you telling me this?`);
        vanessa.talk(`I didn't want to tell Joe and I wanted another person to know.`);
        vanessa.talk(`Anyway, I got to go, Joe is waiting.`);
        vanessa.talk(`Oh, and one last thing.`);
        vanessa.talk(`If she does take it, make sure she doesn't drink too much.`);
        mc.talk(`Why not tell this to her?`);
        vanessa.talk(`I'll see you at the bar in a couple of hours.`);
        vanessa.talk(`Bye!`);
        ImageClass.setImage(images.v4.Door);
        mc.think(`She ignored me and left.`);
        ImageClass.setImage(images.v1.RoomAlone_2);
        mc.think(`I don't know how I feel about that plan...`);
        mc.think(`I just hope things won't get out of hand.`);

    }
    ImageClass.setImage(images.v1.sometimelater);
    return jump(ClubEventJoeOutside1, "ClubEventJoeOutside1");
};

export const ClubEventJoeOutside1 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarOutsideAll3);
    mc.talk(`Hey guys!`);
    joe.talk(`Hey, ${mc.name}! I'm glad you came.`);
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {

        return jump(ClubEventJoeOutsideWentBarAnn, "ClubEventJoeOutsideWentBarAnn");
    }

    return jump(ClubEventJoeOutsideWentBarVanessa, "ClubEventJoeOutsideWentBarVanessa");
};

export const ClubEventJoeOutsideWentBarVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarOutsideAll3);
    if (Question.globalAnswers.afterTODEnteredNaked) {

        ImageClass.setImage(images.v4.BarOutsideAll3_2);
        ann.talk(`Hey ${mc.name}, I'm glad to see you not naked.`);
        mc.talk(`Oh right, we haven't had a chance to talk.`);
        vanessa.talk(`Relax, I already explained everything.`);
    }
    if (mc.properties.annStatus === "natural") {
        ImageClass.setImage(images.v4.BarOutsideAll3);
        if (!Game.seenScenarios.includes(`ClubEventJoe`)) {

            if (Question.globalAnswers.v2VanessaDressLikedTheMost === "redBlack") {

                mc.think(`At least Vanessa is wearing the dress I chose.`);
                if (mc.properties.vanessaRemovedPanties) {

                    mc.think(`But I told her without the panties!`);
                    mc.think(`I guess it was too much even for her.`);
                }

            } else {

                mc.think(`Vanessa isn't wearing the dress I picked...`);
                mc.think(`So why the fuck did she let me chose?`);
            }

        }
    }

    joe.talk(`Girls, you can go inside and find us a place to sit, I want to talk to ${mc.name} for a second.`);
    vanessa.talk(`Let's party!`);
    ImageClass.setImage(images.v4.BarOutsideJoey, { transition: true });

    mc.talk(`Hey Joey, you can still back off.`);
    joe.talk(`Fuck no!\nMy birthday is at midnight.`);
    joe.talk(`I've already seen the bartender before you came.\nI don't have a doubt that's him.`);
    mc.talk(`Did Vanessa say anything?`);
    joe.talk(`No.`);
    joe.talk(`And that's what I wanted to talk to you about.`);
    joe.talk(`The reason I insisted on coming here was so I could see how Vanessa will act around him.`);
    joe.talk(`She keeps telling me she had changed. I want to put her to the test.`);
    mc.talk(`Sounds fair.`);
    joe.talk(`If you see anything strange going on between them let me know.`);
    mc.talk(`I will.`);
    joe.talk(`Alright, we can go in now.`);
    return jump(ClubEventJoeInside, "ClubEventJoeInside");
};

export const ClubEventJoeOutsideWentBarAnn = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarOutsideAll3);
    if (mc.properties.annStatus === "gf") {
        mc.talk(`Ann, you look beautiful.`);
        ann.talk(`Thanks! Hehe.`);
    }
    vanessa.talk(`Well, everyone is here!\nAre we ready to DRINK?`);
    ann.talk(`Mmm...`);
    joe.talk(`Of course!`);
    mc.talk(`Sure!`);
    vanessa.talk(`Come on, let's go inside.`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

        ann.talk(`You guys can enter, I want to talk to ${mc.name} for a minute.`);
        vanessa.talk(`I'll see you inside.`);
        ImageClass.setImage(images.v4.BarOutsideAnn1);
        mc.talk(`What is it?`);

        if (mc.properties.annStatus === "gf") {

            ann.talk(`Well...`);
            ann.talk(`I saw Chris inside.`);
            ann.talk(`And like you know he kept texting me the last few days.`);
            if (Question.globalAnswers.v3KeepAnsweringChris) {

                ann.talk(`You told me to answer him so we exchanged some texts.`);
                ann.talk(`And now it's the first time we'll meet in person after the other night.`);
                ImageClass.setImage(images.v4.BarOutsideAnn2);
                ann.talk(`I just hope it's not going to be awkward.`);
                ann.talk(`You know... Since I'm with you.`);
                mc.talk(`Don't worry about that.`);
                ImageClass.setImage(images.v4.BarOutsideAnn1);
                ann.talk(`But what if he tries anything?`);
                mc.talk(`We'll see once we get there.`);
                mc.talk(`Does he know we are together?`);
                ann.talk(`Yes, I've told him.`);
                mc.talk(`Alright then, let's go inside.`);
            } else {
                ImageClass.setImage(images.v4.BarOutsideAnn2);
                ann.talk(`You told me to ignore him...`);
                ann.talk(`I just hope it's not going to be awkward.`);
                mc.talk(`He is a big boy, he can manage.`);
            }

            ImageClass.setImage(images.v4.BarOutsideAnn3);
            ann.talk(`Ok, I just wanted to say it before we go inside.`);
            ann.talk(`Now we can go and celebrate! Hehe.`);

        } else if (mc.properties.annStatus === "hate") {
            ann.talk(`Well...`);
            ann.talk(`I know that you and I are not on the best terms.`);
            ann.talk(`And I just wanted to ask you if we can put it behind us.\nAt least for tonight.`);
            ann.talk(`I don't want us to ruin the mood.`);
            mc.talk(`Fair enough, I respect that.`);
            ImageClass.setImage(images.v4.BarOutsideAnn3);
            ann.talk(`Great! Hehe.`);
            ann.talk(`We can go inside now.`);
        }

    }

    return jump(ClubEventJoeInside, "ClubEventJoeInside");
};


export const ClubEventJoeInside = async (): Promise<any> => {
    if (mc.properties.annStatus === "natural") {
        ImageClass.setImage(images.v4.BarAllThreeInside1);
        vanessa.talk(`So here we are!`);
        vanessa.talk(`You two are always sneaking around talking about us behind our backs.`);
        mc.talk(`We didn't talk about you.`);
        vanessa.talk(`I don't buy it.`);
        vanessa.talk(`But I also don't care, I just wanna drink.`);
    } else if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        ImageClass.setImage(images.v4.BarAllThreeInside1);
        vanessa.talk(`Finally you are here!`);
        vanessa.talk(`What were you talking about?`);
        mc.talk(`Nothing.`);
        vanessa.talk(`Fine, I don't care anyways.`);
    }

    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {

        return jump(ClubEventJoeInsideWentBarAnn, "ClubEventJoeInsideWentBarAnn");
    }

    return jump(ClubEventJoeInsideWentBarVanessa, "ClubEventJoeInsideWentBarVanessa");

};



export const ClubEventJoeInsideWentBarAnn = async (): Promise<any> => {
    doTransition(images.v4.BarInsideAnnTalking1);
    ann.talk(`Wow, they really changed things.`);
    ann.talk(`The last time we were here it was empty and less noisy.`);

    mc.talk(`It must be working for them.`);
    mc.talk(`I remember that Chris said that they don't get a lot of customers but there are a nice amount of people here.`);
    mc.talk(`We are lucky they still let us inside.`);
    ann.talk(`Yeah, hehe.`);
    return jump(ClubEventJoeInsideDrinking, "ClubEventJoeInsideDrinking");
};


export const ClubEventJoeInsideWentBarVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarInsideAnnTalking1);
    ann.talk(`I've never been to a place like this.`);
    ann.talk(`It's so... dark and noisy.`);
    mc.talk(`Do you like it?`);
    ann.talk(`I can't say that I like it...`);
    ann.talk(`But I also don't hate it.`);
    return jump(ClubEventJoeInsideDrinking, "ClubEventJoeInsideDrinking");
};


export const ClubEventJoeInsideDrinking = async (): Promise<any> => {
    if (Question.globalAnswers.v1WentToTheBarWith === "ann") {

        if (Question.globalAnswers.v3KeepAnsweringChris) {
            ImageClass.setImage(images.v4.BarChrisLeaningToAnn);

        } else {

            ImageClass.setImage(images.v4.BarChrisLookingAtAnn);
        }

        chris.talk(`Hey guys, hey Ann!`);
        ann.talk(`Hey Chris.`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            vanessa.talk(`So you are Chris!`);
            vanessa.talk(`I've heard about you!`);
            ImageClass.setImage(images.v4.BarChrisLeaningToVanessa);
            chris.talk(`Really?`);
            vanessa.talk(`Uh-huh.`);
            chris.talk(`What did you hear?`);
            vanessa.talk(`I heard that you are a bartender, and you like wearing black shirts.`);
            chris.talk(`Continue.`);
            vanessa.talk(`And how you wet your bed sometimes.`);
            chris.talk(`What?`);
            vanessa.talk(`I'm joking.`);
            chris.talk(`You must be Vanessa.`);
            vanessa.talk(`How do you know?`);
            if (Question.globalAnswers.v3KeepAnsweringChris) {
                chris.talk(`Ann told me.`);
                vanessa.talk(`REALLY??`);
                vanessa.talk(`Do you talk a lot?`);
                chris.talk(`When both of us have some free time.`);
                vanessa.talk(`That's very good to know!`);
                vanessa.talk(`Anyways.`);
            } else {
                chris.talk(`Ann told me, till she started to ignore me.`);
                ImageClass.setImage(images.v4.BarChrisLeaningToAnn);
                chris.talk(`You didn't answer my texts today.`);
                ann.talk(`Ahh... Yeah... I was busy.`);
                chris.talk(`Is it something that I said?`);
                ann.talk(`No... I was really busy.`);
                chris.talk(`I hope you won't be busy next time I text...`);
            }

        }
    } else {
        ImageClass.setImage(images.v4.BarChrisLookingAtVanessa);
        chris.talk(`Hey guys, hey Vanessa!`);
        vanessa.talk(`Hey Chris.`);
        mc.think(`Joe doesn't look pleased, I hope it wouldn't ruin his birthday.`);
    }


    vanessa.talk(`Can we have some shots to start this night?`);
    ImageClass.setImage(images.v4.BarChrisLeaningToVanessa);
    chris.talk(`Are you celebrating something special?`);
    vanessa.talk(`A birthday.`);
    chris.talk(`Of course! Shots are coming right out.`);
    if (mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v4.BarVanessaAnnTalking);
        ann.talk(`I was waiting for you to get us something to drink!`);
        vanessa.talk(`Really? No: "Vanessa please get me some water"?`);
        ann.talk(`No. I want to drink.`);
        vanessa.talk(`Who are you and what have you done with my best friend?`);
        vanessa.talk(`You know what, don't answer that.`);
        vanessa.talk(`I like you better!`);
    } else {
        ImageClass.setImage(images.v4.BarVanessaAnnTalking);
        ann.talk(`Vanessa, you forgot to order water for me...`);
        vanessa.talk(`What the fuck Ann, it's Joe's birthday.`);
        ann.talk(`You know I don't drink.`);
        vanessa.talk(`Have you already forgotten what we talked about?`);
        ann.talk(`No...`);
        ann.talk(`Fine...`);
        ann.talk(`But only one!`);
        vanessa.talk(`You will never get a dick inside you with that attitude.`);
        ann.talk(`Vanessa!!!`);
    }

    ImageClass.setImage(images.v4.BarChrisGivingShotsToEveryone);
    chris.talk(`Shots for everyone.`);
    chris.talk(`Since you are celebrating a birthday I brought extra.`);
    chris.talk(`It's on the house!\nJust don't forget to tell your friends about us.`);
    vanessa.talk(`Thanks Chris you are the best.`);
    ImageClass.setImage(images.v4.BarEveryoneCheers);
    vanessa.talk(`What are we waiting for? Let's get this party started!`);


    vanessa.talk(`To Joe's birthday!`);
    joe.talk(`I just want to say that the last year was amazing.`);
    joe.talk(`I had a drastic change in my life, I met Vanessa and I renewed my friendship with ${mc.name}!`);
    mc.talk(`Cheers!`);
    await ann.set((properties) => {
        properties.v4JoeyBirthdayDrinksNum++;
    });
    doWaitImageByTime(images.v4.BarEveryoneDrink, { wait: true });
    ImageClass.setImage(images.v4.BarChrisJoeTalking);
    if (mc.properties.annStatus === "hate") {

        ann.talk(`The taste is not that bad...`);
        ImageClass.setImage(images.v4.BarChrisJoeTalking_VanessaHappy);
        vanessa.talk(`Oh my God, I love the new you!!!`);
        vanessa.talk(`You are going to be my new drinking buddy.`);
    } else {
        ann.talk(`Eww... The taste...`);
        vanessa.talk(`Don't be a baby!`);
    }
    return jump(ClubEventJoeInsideDrinking2, "ClubEventJoeInsideDrinking2");
};

export const ClubEventJoeInsideDrinking2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisJoeTalking);
    vanessa.talk(`By the way, I love your dress!`);
    vanessa.talk(`It's way better than your casual clothes.`);
    ann.talk(`Thank you! It's new, I got it on sale.`);
    ImageClass.setImage(images.v4.BarChrisJoeTalking_VanessaHappy);
    vanessa.talk(`Really? Where?`);
    ann.talk(`Do you know the "Clothes From Heaven" store?`);
    vanessa.talk(`Of course I know it!`);
    ImageClass.setImage(images.v4.BarChrisJoeTalking);
    ann.talk(`So it's the one across the street from there.`);
    vanessa.talk(`Oh... that one.`);
    ann.talk(`Yes, they have amazing sales once in a while.`);
    vanessa.talk(`I never find something good there but I might check it out.`);
    vanessa.talk(`The other day I saw 50% off on...`);

    mc.think(`Oh my fucking God, Joe is busy and I'm stuck in the middle of a girls' talk.`);
    mc.think(`Maybe my phone has something interesting to offer until they are done with this boring conversation.`);

    return jump(ClubEventInstaCheck, "ClubEventInstaCheck");
};

export const ClubEventInstaCheck = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisJoeTalking);
    if (!Game.seenScenarios.includes(`ClubEventInstaCheck`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 70;
            properties.instaFollowers = 73456;
        });
    }
    await UI.add({
        key: "v4BarButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Keep listening", key: "continue" }
            ]
    });
    if (UI._globalUI.v4BarButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v4BarButtons === "continue") {
        if (mc.properties.annStatus === "gf") {

            return jump(ClubEventJoeInsideAnnStatus23, "ClubEventJoeInsideAnnStatus23");
        } else if (mc.properties.annStatus === "hate") {

            return jump(ClubEventJoeInsideAnnStatus1, "ClubEventJoeInsideAnnStatus1");
        }

        return jump(ClubEventJoeInsideAnnStatus0, "ClubEventJoeInsideAnnStatus0");


    }

    return jump(ClubEventInstaCheck, "ClubEventInstaCheck");
};


export const ClubEventJoeInsideAnnStatus0 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarVanessaWhisperingToAnn);
    ann.talk(`Whaaaat?`);
    vanessa.talk(`Shhh!!! Keep your voice down.`, { method: "Whispering" });
    ann.talk(`With him? really?`, { method: "Whispering" });
    vanessa.talk(`Yeah.`, { method: "Whispering" });
    ann.talk(`Oh my God, I can't believe it!`, { method: "Whispering" });
    vanessa.talk(`Does Joe know?`, { method: "Whispering" });
    vanessa.talk(`Of course.`, { method: "Whispering" });
    ann.talk(`And he still agreed to come here?`, { method: "Whispering" });
    vanessa.talk(`I can make him forgive me about anything.`, { method: "Whispering" });
    ann.talk(`Wow... Just wow... hehe.`, { method: "Whispering" });
    vanessa.talk(`Are you drunk? You only drank one shot.`, { method: "Whispering" });
    ann.talk(`I'm not drunk but my head is spinning a little hehe.`, { method: "Whispering" });
    vanessa.talk(`Isn't it nice?`, { method: "Whispering" });
    ann.talk(`It's a funny feeling.`, { method: "Whispering" });
    vanessa.talk(`Since you are in a good mood, don't you think it's also the perfect time for you to get some action?`, { method: "Whispering" });
    ann.talk(`Shhh!`, { method: "Whispering" });
    ann.talk(`Now you are yelling!`, { method: "Whispering" });
    vanessa.talk(`The music is loud no one hears us.`, { method: "Whispering" });
    mc.think(`I can hear them very clearly...`);
    if (Question.globalAnswers.v25JoeTODAgree) {

        return jump(ClubEventJoeInsideAnnStatus0TodAgree, "ClubEventJoeInsideAnnStatus0TodAgree");
    }


    return jump(ClubEventJoeInsideAnnStatus0TodNotAgree, "ClubEventJoeInsideAnnStatus0TodNotAgree");
};



export const ClubEventJoeInsideAnnStatus0TodAgree = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarVanessaWhisperingToAnn);
    vanessa.talk(`What about ${mc.name}? You wanted to meet him.`, { method: "Whispering" });
    ann.talk(`Yes, I did...`, { method: "Whispering" });
    vanessa.talk(`Or maybe Chris! Say the word and I'll get him in your pussy in two seconds.`, { method: "Whispering" });
    ann.talk(`Vanessa! No!`, { method: "Whispering" });
    vanessa.talk(`Oh no!`, { method: "Whispering" });
    vanessa.talk(`Don't tell me you want my Joe!`, { method: "Whispering" });
    vanessa.talk(`You already admitted to like him yesterday.`, { method: "Whispering" });

    ann.talk(`Vanessa!!! I'll tell you if I need help.`, { method: "Whispering" });

    vanessa.talk(`Funny things aside.`, { method: "Whispering" });
    vanessa.talk(`It's the perfect time to get things going.`, { method: "Whispering" });
    vanessa.talk(`You have a nice outfit, everyone is in a good mood.`, { method: "Whispering" });
    vanessa.talk(`You drank one shot, and you can drink a few more to get some confidence.`, { method: "Whispering" });
    ann.talk(`I don't feel comfortable talking about this here, let's go somewhere private.`, { method: "Whispering" });
    if (mc.properties.annStatus === "natural") {
        ImageClass.setImage(images.v4.BarAnnDistracted);
        ann.talk(`Hey ${mc.name}, we will be right back.`);
        mc.think(`Vanessa is putting something in Ann's drink.`);
        mc.think(`That means she gave up on plan A...`);
        mc.talk(`Alright.`);
    }
    return jump(ClubEventJoeInsideJoeAndChris, "ClubEventJoeInsideJoeAndChris");
};


export const ClubEventJoeInsideAnnStatus0TodNotAgree = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarVanessaWhisperingToAnn);
    vanessa.talk(`What about ${mc.name}? You wanted to meet him.`, { method: "Whispering" });
    ann.talk(`Yes, I did...`, { method: "Whispering" });
    ann.talk(`You convinced me to date him and then you asked him to cancel with me.\nThat was so stupid of you.`, { method: "Whispering" });
    vanessa.talk(`Oh my God, we've talked about that already. I needed his help.`, { method: "Whispering" });
    ann.talk(`I don't feel comfortable talking about this when he is sitting right there, let's go somewhere more private.`, { method: "Whispering" });
    ImageClass.setImage(images.v4.BarAnnDistracted);
    ann.talk(`Hey ${mc.name}, we will be right back.`);
    mc.think(`Vanessa is putting something in Ann's drink...`);
    mc.talk(`Alright.`);
    return jump(ClubEventJoeInsideJoeAndChris, "ClubEventJoeInsideJoeAndChris");
};


export const ClubEventJoeInsideAnnStatus1 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisJoeTalking);
    vanessa.talk(`NICE!!!`);
    ann.talk(`Shhh!!! Keep your voice down.`, { method: "Whispering" });
    ImageClass.setImage(images.v4.BarVanessaWhisperingToAnn);
    vanessa.talk(`He is cute! You should make a move.`, { method: "Whispering" });
    ann.talk(`Maybe... We'll see.`, { method: "Whispering" });
    vanessa.talk(`He is totally into you.`, { method: "Whispering" });
    ann.talk(`Do you think? Hehe.`, { method: "Whispering" });
    vanessa.talk(`I am sure!`, { method: "Whispering" });
    ann.talk(`I want to do something crazy tonight...`, { method: "Whispering" });

    vanessa.talk(`Not that I'm complaining but what's got into you???`, { method: "Whispering" });
    ann.talk(`Just tired of getting rejected.`, { method: "Whispering" });
    vanessa.talk(`Is that because of ${mc.name}?`, { method: "Whispering" });
    ann.talk(`Shhh...`, { method: "Whispering" });
    ann.talk(`I don't feel comfortable talking about this here, let's go somewhere more private.`, { method: "Whispering" });
    doWaitImageByTime(images.v4.BarChrisJoeAlone);
    mc.think(`They left.`);
    mc.think(`I wonder what they were talking about, I was too distracted and didn't pay attention.`);
    mc.think(`I can follow them and see...`);

    return jump(ClubEventJoeInsideAnnStatus1_2, "ClubEventJoeInsideAnnStatus1_2");

};


export const ClubEventJoeInsideAnnStatus1_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v4.ToiletVanessaAnn);
    await ann.set((properties) => {
        properties.v4DrankDrug = true;
    });
    vanessa.talk(`Take it already!`);
    mc.think(`I can hear Vanessa.`);
    mc.think(`They are inside the restroom stall.`);
    doWaitImageByTime(images.v4.BarToiletAnnVanessa1);
    ann.talk(`I just asked for an advice, I didn't think you would offer me drugs!`);
    vanessa.talk(`SHHH! Now you are yelling!`);
    vanessa.talk(`And it's not drugs, it's vitamins.`);
    ann.talk(`Yeah, right.`);
    vanessa.talk(`Come onnnn! Just try it.`);
    ann.talk(`Are you sure about that?`);
    vanessa.talk(`Yes!`);
    ann.talk(`But the guys might see I'm acting differently.`);
    vanessa.talk(`They won't. It's not what you think.`);
    vanessa.talk(`Plus, it takes time to take effect.`);
    ann.talk(`Fine, but don't say anything to anyone!`);
    ann.talk(`Can you bring me a glass of water?`);
    vanessa.talk(`You can drink from the toilet.`);
    ann.talk(`Very funny!`);
    vanessa.talk(`It's small, just swallow it.`);
    vanessa.talk(`It can be good practice for you.`);
    ann.talk(`Your jokes are something...`);
    vanessa.talk(`Take it already.`);
    ImageClass.setImage(images.v4.BarToiletAnnVanessa2);
    ann.talk(`My parents are going to kill me.`);
    vanessa.talk(`Oh yeah, and don't drink too much, one or two more shots will be fine.`);
    mc.think(`I should get back before they see me.`);
    return jump(ClubEventJoeInsideJoeAndChris, "ClubEventJoeInsideJoeAndChris");
};
export const ClubEventJoeInsideAnnStatus23 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisJoeTalking_VanessaHappy);
    vanessa.talk(`WHAT? DETAILS! NOW!`);
    ann.talk(`Shhh! You are yelling.`, { method: "Whispering" });
    ImageClass.setImage(images.v4.BarVanessaWhisperingToAnn);
    vanessa.talk(`He is too busy with his phone anyway.`, { method: "Whispering" });
    vanessa.talk(`Come on, give me the details!`, { method: "Whispering" });
    ann.talk(`Remember our conversation?`, { method: "Whispering" });
    vanessa.talk(`Which one? I usually lose consciousness when you talk about your books.`, { method: "Whispering" });
    ann.talk(`Uff... The one that I told you that I think it's time for me to experience new stuff...`, { method: "Whispering" });
    vanessa.talk(`Oh! Why didn't you say that's the one that you said that you want a dick in you?`, { method: "Whispering" });
    ann.talk(`I didn't put it in that way, but that's the one.`, { method: "Whispering" });
    ann.talk(`So earlier I was at ${mc.name}'s house... And we did some things...`, { method: "Whispering" });
    vanessa.talk(`O-M-G, get it out already you aren't in first grade anymore.`, { method: "Whispering" });
    ann.talk(`Fine fine, I gave him a handjob...`, { method: "Whispering" });
    vanessa.talk(`And???`, { method: "Whispering" });
    ann.talk(`That's it.`, { method: "Whispering" });
    vanessa.talk(`Well, I guess it's something for you.`, { method: "Whispering" });
    vanessa.talk(`I am happy for you!`, { method: "Whispering" });
    ann.talk(`Thanks, hehe.`, { method: "Whispering" });
    vanessa.talk(`How was the feeling? Did you like it?`, { method: "Whispering" });
    ann.talk(`Actually, I did. Hehehe.`, { method: "Whispering" });
    vanessa.talk(`Did he cum???`, { method: "Whispering" });
    if (Question.globalAnswers.v3HJGuidedAnn) {


        ann.talk(`He did.`, { method: "Whispering" });
        vanessa.talk(`GREAT JOB!`, { method: "Whispering" });
        vanessa.talk(`But next time you should use your mouth.`, { method: "Whispering" });
    } else {
        ann.talk(`He didn't...`, { method: "Whispering" });
        vanessa.talk(`Because you didn't suck him!`, { method: "Whispering" });
        vanessa.talk(`Why do you have a mouth?`, { method: "Whispering" });
        ann.talk(`To talk...`, { method: "Whispering" });
        vanessa.talk(`Wrong! The dick fits in your mouth for a reason!`, { method: "Whispering" });
        ann.talk(`Oh my God, Vanessa...`, { method: "Whispering" });
    }
    if (Question.globalAnswers.v3ConvincedAnnBJ) {
        ann.talk(`He did ask for it...`, { method: "Whispering" });
        vanessa.talk(`Of course he did, he is a man.`, { method: "Whispering" });
        vanessa.talk(`Did you do it?`, { method: "Whispering" });
        ann.talk(`I gave it a kiss...`, { method: "Whispering" });
        if (Question.globalAnswers.v3ShovedAnnHeadForBJ) {
            ann.talk(`But it wasn't enough for him...`, { method: "Whispering" });
            ann.talk(`He shoved my head down hard I almost choked!`, { method: "Whispering" });
            vanessa.talk(`Haha what an asshole!`, { method: "Whispering" });
        } else {


            vanessa.talk(`That's it?`, { method: "Whispering" });
            ann.talk(`Yes.`, { method: "Whispering" });
            vanessa.talk(`Boring!`, { method: "Whispering" });
        }
    }
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

        vanessa.talk(`And what about Chris?? You told me you two were texting!`);
    } else {

    }
    ann.talk(`Can we continue the conversation somewhere more private?`, { method: "Whispering" });
    vanessa.talk(`Sure, let's go.`);

    return jump(ClubEventJoeInsideJoeAndChris, "ClubEventJoeInsideJoeAndChris");

};


export const ClubEventJoeInsideJoeAndChris = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisJoeAlone, { duration: 0.6 });
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        chris.talk(`So I hope we are good here bro.`);
        joe.talk(`I get it, man.`);
    }
    if (mc.properties.annStatus === "hate") {

        chris.talk(`I see that your friend is back.`);
    } else {

        chris.talk(`I see that your friend is sitting alone.`);
    }
    chris.talk(`I won't take up more of your time.`);
    chris.talk(`If you need anything, just tell me.`);
    joe.talk(`Thanks, bro.`);
    doWaitImageByTime(images.v4.BarChrisJoeAlone2);
    chris.talk(`And happy birthday.`);
    ImageClass.setImage(images.v4.BarJoeAlone, { transition: true });
    joe.talk(`Where are the girls?`);
    mc.talk(`They went to the restroom to talk about something.`);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

        mc.talk(`But first. What happened there? You were chatting for some time now.`);
        joe.talk(`He is a cool dude... Considering all that has happened.`);
        mc.talk(`Are you friends now?`);
        joe.talk(`Not exactly.`);
        joe.talk(`He apologized for what he did with Vanessa, he said that if he knew she had a boyfriend he wouldn't have done that.`);
        mc.talk(`Do you believe him?`);
        joe.talk(`I kinda do, yes.`);
        joe.talk(`That doesn't mean we are going to be bros for life, but I can understand where he is coming from.`);
        joe.talk(`When a girl like Vanessa starts to flirt with you, she will get what she wants.`);
        mc.talk(`That's very noble of you.`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber !== true || Question.globalAnswers.v25JoeTODAgree !== true) {

            mc.talk(`I don't know if I could forgive him like you just did.`);
        }

        joe.talk(`Thanks man.`);
    } else {
        mc.talk(`What were you and Chris talking about?`);
        joe.talk(`Nothing special, just chit chat.`);
        joe.talk(`He wanted to know if Vanessa is my girlfriend.`);
        joe.talk(`I said yes and that's about it.`);
        mc.talk(`You summed up in one line a conversation that seemed way longer.`);
        joe.talk(`He was in a chatty mood, he shared some stories he had while working here.`);
        mc.talk(`Anything worth mentioning?`);
        joe.talk(`Haha, I didn't think that bartender life can be boring.`);
        mc.talk(`Unless you get no customers.`);
        joe.talk(`That's not true, you just need two female customers to get the evening to be interesting.`);
        mc.talk(`As long as they are hot.`);
        joe.talk(`Haha, of course.`);
        joe.talk(`Well, yeah, he is a cool dude.`);
        mc.talk(`So you got yourself a new friend.`);
        joe.talk(`Not as good as you.`);
    }

    if (mc.properties.annStatus === "natural") {
        joe.talk(`Where are the girls? I'm dying for another drink!`);
        mc.think(`Vanessa put something in Ann's drink.`);
        await mc.setQuestion(new Question({ text: `I can be an asshole friend and trick him to drink it.`, options: { think: true }, key: `v4TrickJoeyDrinkDrug` })
            .option({ title: `Trick him`, key: true })
            .option({ title: `Don't trick him`, key: false }));


        if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {
            mc.talk(`Joe, these shots are just sitting there.`);
            mc.talk(`It's your birthday, let's drink!`);
            joe.talk(`You know what?`);
            joe.talk(`Let's do it!`);
            ImageClass.setImage(images.v4.BarJoeAloneDrinking, { wait: 2 });
            await joe.set((properties) => {
                properties.v4DrankDrug = true;
            });
        }
    }

    ImageClass.setImage(images.v4.BarJoeAlone);

    if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {

        joe.talk(`Damn I needed that.`);
    } else {

    }

    joe.talk(`You are a really good friend ${mc.name}.`);
    joe.talk(`I'm really happy to have you by my side.`);
    return jump(ClubEventJoeInsideJoeAndChris2, "ClubEventJoeInsideJoeAndChris2");
};

export const ClubEventJoeInsideJoeAndChris2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarJoeAlone2);


    mc.think(`Is that Vanessa dancing in the background?`);
    mc.think(`Ann is not back yet.`);

    joe.talk(`You know, I'm glad we had that talk at the gym today.`);
    joe.talk(`I spent some time thinking.`);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        joe.talk(`I know that Vanessa does stupid shit sometimes.`);

    }
    ImageClass.setImage(images.v4.BarJoeAlone3);
    joe.talk(`But I realized she really cares for me.`);
    await joe.setQuestion(new Question({ text: `I feel like she is really changing for the best.`, key: `v4ToldJoeyToTurnAround` })
        .option({ title: `Tell him to turn around`, key: true })
        .option({ title: `Say nothing`, key: false }));


    if (Question.globalAnswers.v4ToldJoeyToTurnAround) {

        return jump(ClubEventJoeInsideTurnAround, "ClubEventJoeInsideTurnAround");
    } else {

        return jump(ClubEventJoeInsideDontTurnAround, "ClubEventJoeInsideDontTurnAround");
    }
};


export const ClubEventJoeInsideTurnAround = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarJoeAlone3);
    mc.talk(`Joey... You should turn around.`);
    ImageClass.setImage(images.v4.BarJoeTurned1);
    joe.talk(`What the fuck?!`);
    ImageClass.setImage(images.v4.BarJoeTurned2);
    joe.talk(`What the fuck do you think you are doing?! That's my girlfriend!`);
    ImageClass.setImage(images.v4.BarJoeTurned3);
    rick.talk(`So put a leash on her.`);
    rick.talk(`She started dancing with me.`);
    joe.talk(`I don't fucking care, stay away from her.`);
    ImageClass.setImage(images.v4.BarJoeTurned4);
    joe.talk(`${mc.name}, let's go outside I need to relax.`);
    ImageClass.setImage(images.v4.BarVanessaJoeOutsideFight1);
    joe.talk(`Vanessa? We've talked about that!`);
    vanessa.talk(`I'm sorry Boo. I drank too much, I thought he was you!`);
    joe.talk(`He doesn't even look like me.`);
    joe.talk(`And you drank only one shot!`);
    vanessa.talk(`I'm sorry, let's just go home.`);
    ImageClass.setImage(images.v4.BarVanessaJoeOutsideFight2);
    joe.talk(`${mc.name}, we are going. Sorry for cutting the night short.`);
    mc.think(`She should win an Oscar...`);
    joe.talk(`Tell Ann I'm happy that she came.`);
    mc.talk(`Shit, I almost forgot about her.`);
    mc.talk(`Bye Joey, bye Vanessa.`);

    return jump(ClubEventJoeInsideTurnAroundAfterAnnAlone, "ClubEventJoeInsideTurnAroundAfterAnnAlone");
};


export const ClubEventJoeInsideTurnAroundAfterAnnAlone = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneNoVan1, { transition: true });
    ann.talk(`What happened? Where were you? I thought you left.`);
    mc.talk(`There was some drama with Vanessa.`);
    mc.talk(`She started dancing with some guy... Joe saw her and got upset.`);

    return jump(ClubEventJoeInsideAnnAlone, "ClubEventJoeInsideAnnAlone");
};

export const ClubEventJoeInsideDontTurnAround = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarJoeAlone3);
    joe.talk(`I really believe I can make an honest woman out of her.`);
    joe.talk(`All the guys that were before me just couldn't understand her.`);
    ImageClass.setImage(images.v4.BarJoeAloneNoVanessa, { duration: 0.6 });

    joe.talk(`But enough about me!`);
    if (mc.properties.annStatus === "natural") {
        joe.talk(`You should make a move on Ann tonight.`);
        joe.talk(`I know she only drank one shot but she never drinks, it might loosen her up a bit...`);
        joe.talk(`Now that I know the truth, that you didn't meet with her the other day it could be the perfect opportunity.`);
        joe.talk(`If you need me gone just nod your head and I'll be out of your way.`);
        mc.talk(`Thanks, Joey, but I think I got this.`);
        joe.talk(`Of course! Just trying to help. Haha.`);
        mc.talk(`Yeah I know, I appreciate it.`);
    } else if (mc.properties.annStatus === "hate") {
        joe.talk(`Did you apologize to Ann?`);
        mc.talk(`Not an official apology, but we are on good terms right now, why?`);
        joe.talk(`I was just curious, from what I can see it looks like you are getting along nicely.`);
        mc.talk(`We agreed to put our differences aside.`);
        mc.talk(`We didn't want to ruin the mood.`);
        joe.talk(`Thanks!`);

        if (Question.globalAnswers.v3JoeGymWhyDislikeAnn === "IChangedMyMind") {

            joe.talk(`Anyways, earlier you said that you changed your mind about her, that's why I asked.`);
            mc.talk(`I did, but I'll have to work hard for that now.`);
            joe.talk(`Yes, I can understand.`);
        }

    } else {
        joe.talk(`Did you meet with Ann after you left the gym?`);
        mc.talk(`I did.`);
        await joe.setQuestion(new Question({ text: `What happened??? Talk to me!`, key: `v4ToldJoeDetailsAboutAnn` })
            .option({ title: `Tell him the details`, key: true })
            .option({ title: `Don't tell him`, key: false }));


        if (Question.globalAnswers.v4ToldJoeDetailsAboutAnn) {
            await mc.set((properties) => {
                properties.alpha++;
            });
            mc.talk(`Well, she came over to my place with a plan.`);
            mc.talk(`After a small talk she took off her clothes and we moved to the bed.`);

            ImageClass.setImage(images.v4.BarJoeAloneNoVanessa_Smile);
            joe.talk(`Nice!`);
            ImageClass.setImage(images.v4.BarJoeAloneNoVanessa);
            mc.talk(`She started giving me a handjob, but I could tell she lacked experience.`);
            if (Question.globalAnswers.v3HJGuidedAnn) {

                mc.talk(`Once I guided her, it started to feel good.`);
            } else {

                mc.talk(`But I didn't want her to lose her confidence, so I said nothing.`);
            }

            joe.talk(`Keep going!`);
            mc.talk(`That's what I said.`);
            ImageClass.setImage(images.v4.BarJoeAloneNoVanessa_Smile);
            mc.talk(`Anyway!`);
            if (Question.globalAnswers.v3ConvincedAnnBJ) {
                mc.talk(`I tried to convince her to suck me but she only agreed to give my cock a small kiss.`);
                if (Question.globalAnswers.v3ShovedAnnHeadForBJ) {
                    mc.talk(`I was so fucking horny so I shoved her head once she leaned over for the kiss.`);
                    ImageClass.setImage(images.v4.BarJoeAloneNoVanessa_Surprise);
                    joe.talk(`Oh my God, bro! Haha, that's nasty, I can't believe you really did it.`);
                    ImageClass.setImage(images.v4.BarJoeAloneNoVanessa_Smile);
                    joe.talk(`At the gym I told you to try to push to get things going but I didn't expect it physically, haha.`);
                    joe.talk(`I bet she was pissed.`);
                    mc.talk(`She was a bit mad, but she got over it.`);
                }

            } else {
                mc.talk(`I wanted a blowjob but I didn't say anything. I just wanted her to keep going.`);
                joe.talk(`You should have asked her...`);
                mc.talk(`Well, that's in the past now.`);
            }

            joe.talk(`Did you cum at least?`);
            if (Question.globalAnswers.v3HJGuidedAnn) {
                mc.talk(`Yes I did.`);
                joe.talk(`Nice!`);
                joe.talk(`I'm glad things are working out for you! You deserve it.`);
                mc.talk(`Thanks Joey.`);
            } else {
                mc.talk(`No, I didn't, she wasn't good enough.`);
                joe.talk(`Damn, that's tough.`);
                joe.talk(`I am sure she will get better.`);
                joe.talk(`Regardless, I am happy that things are working out for you.`);
            }

        } else {
            await mc.set((properties) => {
                properties.alpha--;
            });
            mc.talk(`We just hanged out.`);
            joe.talk(`Come on! Don't lie to me, something must have happened.`);
            mc.talk(`Something did happen, but I don't want to share the details, I don't think it's fair to Ann.`);
            joe.talk(`Whatever bro.`);
        }
    }

    return jump(ClubEventJoeInsideDontTurnAround2, "ClubEventJoeInsideDontTurnAround2");
};

export const ClubEventJoeInsideDontTurnAround2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarJoeAloneNoVanessa);

    joe.talk(`I think I should go look for the girls. They are taking forever.`);
    mc.talk(`No no, let me.`);
    joe.talk(`Fine, I'll be here.`);
    ImageClass.setImage(images.v4.BarVanessaToilet1, { transition: true });
    mc.think(`Where are they?`);
    if (mc.properties.annStatus === "hate") {
        mc.think(`I saw them here just moments ago.`);

    }
    stranger.talk(`Oh my God.`);
    vanessa.talk(`Do you like it?`);
    stranger.talk(`Fuck yes!`);
    mc.think(`That sounds like Vanessa...`);
    mc.think(`Is she in there with that guy she was dancing with?`);
    ImageClass.setImage(images.v4.BarVanessaToilet2);
    mc.think(`That slut...`);
    if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {
        mc.think(`But we've talked about her, I asked her to stop and hurt Joey.`);

    } else if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {

        mc.think(`What's wrong with that girl?`);
        mc.think(`My dick wasn't enough for her for one day?`);
    }

    mc.think(`Joey was right about her, she is a real nympho.`);
    ImageClass.setImage(images.v4.BarVanessaToilet3);
    doDoorKnock();
    stranger.talk(`OCCUPIED!`);
    mc.think(`Even though it's her dress I gotta be sure.`);
    ImageClass.setAnimation(images.v4.Anim_BarVanessaToilet);
    mc.think(`I knew it...`);

    mc.think(`I better get back before Joe comes looking for her himself.`);
    ImageClass.setImage(images.v4.BarVanessaToilet1);
    stranger.talk(`Ahhhh, fuck! Sexy slut.`);
    await endReplay(replayScenesList.v4VanessaRickToiletBJ);
    return jump(ClubEventJoeInsideDontTurnAround3, "ClubEventJoeInsideDontTurnAround3");
};


export const ClubEventJoeInsideDontTurnAround3 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnJoe1, { transition: true });
    if (mc.properties.annStatus === "hate") {

        mc.think(`Ann is finally here.`);
        mc.think(`What took her so long to get back?`);
    } else {

        mc.think(`Ann is here.`);
    }

    mc.talk(`Ann, you are back.`);
    ImageClass.setImage(images.v4.BarAnnJoe);
    joe.talk(`Yeah, she just got here.`);
    joe.talk(`Did you find Vanessa?`);
    mc.think(`I can't do that to him on his birthday.`);
    mc.talk(`No, I haven't.`);
    ann.talk(`Weird, she went with me to the restroom and then she said she was going dancing...`);
    joe.talk(`I didn't see her in the crowd.`);
    joe.talk(`I hope nothing happened to her.`);
    ImageClass.setImage(images.v4.BarVanessaBack);
    vanessa.talk(`To who?`);
    mc.talk(`You see.`);
    joe.talk(`You are back.`);
    joe.talk(`You were gone for a long time.`);
    vanessa.talk(`I didn't know I'm going to compete in the pissing Olympic...`);
    ImageClass.setImage(images.v4.BarVanessaWhisperingToJoe);
    mc.think(`She is whispering something to Joey...`);
    if (Question.globalAnswers.v4TrickJoeyDrinkDrug) {
        ImageClass.setImage(images.v4.BarVanessaBack2_empty);
    } else {

        ImageClass.setImage(images.v4.BarVanessaBack2);
    }
    joe.talk(`Guys, thanks for coming, but we are going.`);
    mc.talk(`Already? We just got here.`);
    vanessa.talk(`Yes!`);
    vanessa.talk(`Enjoy the rest of the night. Lovebirds!`);

    return jump(ClubEventJoeInsideDontTurnAroundAfterAnnAlone, "ClubEventJoeInsideDontTurnAroundAfterAnnAlone");
};

export const ClubEventJoeInsideDontTurnAroundAfterAnnAlone = async (): Promise<any> => {
    doWaitImageByTime(images.v4.BarAnnAloneNoVan4);
    ann.talk(`I thought they would stay longer.`);
    mc.talk(`Yeah, me too.`);
    return jump(ClubEventJoeInsideAnnAlone, "ClubEventJoeInsideAnnAlone");
};


export const ClubEventJoeInsideAnnAlone = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneNoVan1);
    if (Game.seenScenarios.includes(`ClubEventJoeInsideTurnAroundAfterAnnAlone`)) {

        ann.talk(`I saw that...`);
    } else {

        ann.talk(`You know... I saw her dancing with that guy.`);
    }
    mc.talk(`Really? Why didn't you say anything?`);
    ann.talk(`I don't know. I didn't want to get in the way.`);
    ann.talk(`Vanessa is my friend, and Joe looks like a nice guy.`);
    ann.talk(`It's only the second time I've seen him in real life, and it's sad what she is doing to him.`);
    mc.talk(`He is not stupid, he is just blind.`);
    ann.talk(`That's not the first time she's done that.`);
    ann.talk(`I've seen her with many guys before, but as of now he has stayed with her the longest, that I know of.`);
    mc.talk(`How many guys are we talking about?`);
    ann.talk(`Well... There were a lot, but she considered only a few as her "boyfriends".`);
    mc.talk(`It's always amazes me that you two are friends but also so different.`);
    ann.talk(`You and Joe are also different.`);
    mc.talk(`We used to be very similar.`);
    ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
    ann.talk(`Yeah... I guess you are right.`);
    mc.talk(`Well, what's done is done.`);
    mc.talk(`But I do know one thing.`);
    mc.talk(`We don't need to end the night just because they left.`);
    mc.talk(`The night is still young and there are drinks left.`);
    if (mc.properties.annStatus === "hate") {
        ann.talk(`Fuck it, let's do it.`);
        mc.talk(`When did you start to cuss?`);
        ann.talk(`Just now.`);
        mc.think(`I haven't know her for that long but it looks like she is trying to change.`);
        ImageClass.setImage(images.v4.BarAnnAloneNoVan3, { wait: 2 });
        await ann.set((properties) => {
            properties.v4JoeyBirthdayDrinksNum++;
        });
    } else {
        await ann.setQuestion(new Question({ text: `But we drank already.`, key: `v4ConvinceAnnToDrinkMore` })
            .option({ title: `Convince her`, key: true })
            .option({ title: `Don't Convince`, key: false }));

        if (Question.globalAnswers.v4ConvinceAnnToDrinkMore) {
            if (Question.globalAnswers.v4TrickJoeyDrinkDrug === false) {
                if (mc.properties.annStatus !== "gf") {
                    await ann.set((properties) => {
                        properties.v4JoeyBirthdayDrinksNum = 1;
                        properties.v4DrankDrug = true;
                    });
                }

            }
            await ann.set((properties) => {
                properties.v4JoeyBirthdayDrinksNum++;
            });
            if (mc.properties.alpha > 4) {
                mc.talk(`Ann.`);
                ann.talk(`Yes?`);
                mc.talk(`We are going to drink.`);
                ann.talk(`Ok ok.`);
                ImageClass.setImage(images.v4.BarAnnAloneNoVan3, { wait: 2 });
                mc.think(`Who knew? Little Ann starting to obey my commands.`);
            } else {
                mc.talk(`Come on, Ann.`);
                mc.talk(`You are always studying hard, it's time for you to relax and have some fun!`);
                ann.talk(`I do study a lot...`);
                ann.talk(`Don't tell Vanessa but I kinda liked the dizzy feeling, and it started to fade away.`);
                mc.talk(`So let's drink!`);
                ann.talk(`Hehe, ok.`);
            }
            ImageClass.setImage(images.v4.BarAnnAloneNoVan3, { wait: 2 });
            if (Question.globalAnswers.v4TrickJoeyDrinkDrug === false) {

                mc.think(`Ann is drinking the shot that Vanessa put something in.`);
            } else {

            }

        } else {
            await ann.set((properties) => {
                properties.v4DrankDrug = false;
            });
            mc.talk(`You are right.\nForget about that.`);
        }
    }

    return jump(ClubEventJoeInsideAnnAloneStatus01InstaTalk, "ClubEventJoeInsideAnnAloneStatus01InstaTalk");
};

export const ClubEventJoeInsideAnnAloneStatus01InstaTalk = async (): Promise<any> => {
    if (ann.properties.v4JoeyBirthdayDrinksNum > 1) {
        if (mc.properties.joeStatus === "enemy") {
            ImageClass.setImage(images.v4.BarAnnAloneNoDrinks);

        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
        }
    } else {
        if (mc.properties.joeStatus === "enemy") {
            ImageClass.setImage(images.v4.BarAnnAloneNoDrinks);

        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        }
    }
    if (mc.properties.annStatus === "gf") {
        ann.talk(`So, what do you think of Alex?`);
        mc.talk(`Alex? Where did that come from?`);
        ann.talk(`While I was talking with Vanessa I saw you on your phone and I know that you are following her...`);
        mc.talk(`I started following her before I met you.`);
        ann.talk(`Oh ok, hehe.`);
        mc.talk(`Does it bother you?`);
        ann.talk(`No.`);
    } else {
        mc.talk(`I saw that you opened Insta.`);
        ann.talk(`Yes... I got bored.`);
        mc.talk(`You? Bored? Don't you usually pass your time reading books?`);
        ann.talk(`I do, I just didn't feel like doing that.`);
        ann.talk(`Besides, Alex hasn't stop bugging me for the last few days to open one.`);
    }
    if (Question.globalAnswers.v3mcAnnLibraryAskedAboutAlex) {

        ann.talk(`I don't need to tell you who that is, I know you know her.`);
        mc.talk(`I do.`);
    } else {
        if (getInstaImage(Insta.instaProfiles[alex.name], `${alex.name}8`)?.mcSeen) {
            mc.talk(`You know, I saw you on her profile.`);
            ann.talk(`Really??`);
            ann.talk(`I saw she uploaded a photo of the both of us... I told her to delete it but she doesn't want to.`);
            ann.talk(`Do you know her?`);
            mc.talk(`From Insta... Yes.`);
            ann.talk(`Oh.`);
            ann.talk(`She did tell me she is getting tons of likes and followers so I'm not surprised you came across her.`);
        } else {
            ann.talk(`I'm sure you came across her, it's hard to miss her.`);
            mc.talk(`I did.`);
        }
    }

    mc.talk(`How did you become friends in the first place?`);
    ann.talk(`We went to the same school when we were little.`);
    ann.talk(`But she moved out to a different city, she just recently came back.`);
    mc.talk(`Does that mean she also knows Vanessa?`);
    ann.talk(`No, she doesn't, me and Vanessa became friends through our parents, but we didn't go to the same school.`);
    mc.talk(`Oh, I don't know why I was thinking you were at the same school.`);
    ann.talk(`No... Hehe.`);
    ann.talk(`How to say it nicely...`);
    ann.talk(`My school was harder to get into than Vanessa’s.`);
    mc.talk(`Got it.`);

    mc.talk(`So wait, Alex doesn't seem like studying is her first priority... How did she get in?`);
    ann.talk(`She wasn't like that before...`);
    ann.talk(`She used to be like me.`);
    ann.talk(`Guys didn't pay that much attention to her...`);
    ann.talk(`I mean, they didn't completely ignore her, she is still a blonde... Hehe.`);
    ann.talk(`Her body started to change just recently, that's why she went to the extreme with all that Insta thing.`);
    ann.talk(`She really likes the attention she is getting now.`);

    ann.talk(`I told her that it's fake, the guys just want to see her naked.`);
    ann.talk(`But I think she is too invested in it now.`);
    mc.talk(`She could have gotten addicted to worst stuff.`);
    ann.talk(`Yes, that's true.`);
    mc.talk(`As long as she is not hurting anyone, and the fact that it makes her happy, so why not?`);
    mc.talk(`I also know you can get tons of money from that.`);
    ann.talk(`Really? How?`);
    mc.talk(`If you reach the point that you have a lot of followers you will start getting offers to publish some of their shit.`);
    mc.talk(`And of course you will also get to keep their product for free.`);
    ann.talk(`Wow, I didn't know that, I wonder if Alex does.`);
    mc.talk(`If she doesn't, she will know that soon.`);
    if (mc.properties.joeStatus === "enemy") {

        return jump(ClubEventWithoutJoeInsideVanessaDancing3, "ClubEventWithoutJoeInsideVanessaDancing3");
    }

    ann.talk(`Well, enough about her.`);
    if (mc.properties.annStatus === "natural") {

        ann.talk(`There is something I want to say.`);
        return jump(ClubEventJoeInsideAnnAloneStatus0, "ClubEventJoeInsideAnnAloneStatus0");
    } else if (mc.properties.annStatus === "hate") {
        return jump(ClubEventJoeInsideAnnAloneStatus1, "ClubEventJoeInsideAnnAloneStatus1");
    }

    return jump(ClubEventJoeInsideAnnAloneStatus23, "ClubEventJoeInsideAnnAloneStatus23");
};

export const ClubEventJoeInsideAnnAloneStatus0 = async (): Promise<any> => {
    if (ann.properties.v4JoeyBirthdayDrinksNum > 1) {

        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks);

        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
        }

    } else {

        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks2);

        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        }
    }
    ann.talk(`I can't help but thinking... What would have happened if you came here with me the other night instead of Vanessa?`);
    mc.talk(`It's funny that you say that.`);
    mc.talk(`Because while we were playing spin the bottle you said that you like Joey.`);
    ann.talk(`Yeah... About that... He was just the first name that popped into my head.`);
    if (Question.globalAnswers.v3mcAnnLibraryCheckedAnnPhone && Question.globalAnswers.v25JoeTODAgree) {

        mc.think(`That's a lie, I saw that she was texting Joey.`);
    }
    ann.talk(`Vanessa keeps talking about how great he is so I couldn't think of anyone else at that moment.`);
    mc.talk(`Really? No one else?`);
    ann.talk(`Yeah...`);
    ann.talk(`And I believe it's my fault.`);
    ann.talk(`And sometimes it makes me sad...`);
    mc.talk(`Why do you think it's your fault?`);
    return jump(ClubEventJoeInsideAnnAloneStatus0_Question, "ClubEventJoeInsideAnnAloneStatus0_Question");
};

export const ClubEventJoeInsideAnnAloneStatus0_Question = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`ClubEventWithoutJoe`)) {
        if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 1) {
            ImageClass.setImage(images.v4.BarAnnAloneNoVan2);

        } else {
            ImageClass.setImage(images.v4.BarAnnAloneNoVan4);

        }

    } else {
        if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 1) {
            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks);

        }
        ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks2);

    }


    await ann.setQuestion(new Question({ text: `The way I act.`, key: `v4AnnBarFlirtedHer` })
        .option({ title: `Let her talk`, key: false })
        .option({ title: `Flirt`, key: true }));


    if (Question.globalAnswers.v4AnnBarFlirtedHer) {
        await mc.set((properties) => {
            properties.annRelationship++;
        });
        mc.talk(`Don't be.`);
        mc.talk(`You are very attractive and cute.`);
        ann.talk(`Oh stop it, hehe.`);
        mc.talk(`It's true.`);
        mc.talk(`You have a great personality, I really like it.`);
        ann.talk(`Most guys don't like it.`);
        ann.talk(`I think they just don't get me. They want a girl like Vanessa.`);
        ann.talk(`Don't tell her I said that, but girls like Vanessa are usually for a one night stand.`);
        mc.talk(`You are not like that and most guys just don't have the patience, and I am happy they don't because it leaves more room for me.`);
        ann.talk(`Hehe.`);
    } else {
        ann.talk(`Don't get me wrong, I love myself but sometimes I think I can do better.`);
        ann.talk(`I look at Vanessa and how she's living her life on her own terms and everyone seems to love her.`);
        ann.talk(`So it makes me wonder if I'm doing something wrong.`);
        ann.talk(`But it's not like I want to be like her! Far from that.`);
        ann.talk(`But I love her approach on life, she does what she wants without a care in the world.`);
        ann.talk(`I can't help but wonder what it's like to be her.`);
        ann.talk(`I guess it's both a good and bad trait of mine.`);
        ann.talk(`That, and talking... Hehe.`);
        ann.talk(`I do talk a lot sometimes... When I'm nervous.`);
    }
    if (ann.properties.v4DrankDrug) {
        ann.talk(`You are a great listener, thank you.`);
        ImageClass.setImage(images.v4.BarAnnKiss1);
        mc.think(`Woah, she is trying to kiss me all of the sudden.`);
        if (mc.properties.joeStatus !== "enemy") {
            mc.think(`I guess that's Vanessa's magic pill starting to kick in.`);

        }
        return jump(ClubEventJoeInsideAnnAloneStatus0_AnnDrankDrug_Question, "ClubEventJoeInsideAnnAloneStatus0_AnnDrankDrug_Question");
    }

    mc.talk(`There is no reason to be nervous.`);
    ann.talk(`Oh ok...`);
    ann.talk(`I want to ask you something but I think it's really stupid.`);
    if (Question.globalAnswers.v4WithoutJoeyLiedToAnn) {
        ann.talk(`And I really don't know if I should say it... especially after what you just told me...`);
        ann.talk(`You know, forcing Vanessa and all of that...`);
        ann.talk(`But I am going to say it anyway.`);
    }
    mc.talk(`What is it?`);
    ann.talk(`Promise not to laugh.`);
    mc.talk(`I won't.`);
    ann.talk(`What do you think about me?`);
    mc.talk(`What do you mean?`);
    ann.talk(`I mean... Do you like me?`);
    return jump(ClubEventJoeInsideAnnAloneStatus0_AnnDidntDrinkDrug_Question, "ClubEventJoeInsideAnnAloneStatus0_AnnDidntDrinkDrug_Question");
};


export const ClubEventJoeInsideAnnAloneStatus0_AnnDrankDrug_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnKiss1);
    await mc.setQuestion(new Question({ text: `...`, key: `v4BarKissedAnnBack` })
        .option({ title: `Kiss her back`, key: true })
        .option({ title: `Don't kiss her`, key: false }));


    if (Question.globalAnswers.v4BarKissedAnnBack) {
        await mc.set((properties) => {
            properties.annLateGF = true;
            properties.annStatus = "gf";
            properties.annRelationship += 2;

        });
        ImageClass.setImage(images.v4.BarAnnKissAlone, { wait: true });
        ImageClass.setImage(images.v4.BarAnnKiss2);
        ann.talk(`That's nice.`);
        ImageClass.setImage(images.v4.BarAnnKissAlone, { wait: true });
        return jump(ClubEventJoeInsideAnnAloneStatus0_Continue, "ClubEventJoeInsideAnnAloneStatus0_Continue");
    }
    ImageClass.setImage(images.v4.BarAnnKiss2);
    mc.talk(`Ann.`);
    mc.talk(`We shouldn't.`);
    ann.talk(`What?`);

    return jump(ClubEventJoeInsideAnnAloneStatus0_AnnDrankDrug_Relation_Question, "ClubEventJoeInsideAnnAloneStatus0_AnnDrankDrug_Relation_Question");


};


export const ClubEventJoeInsideAnnAloneStatus0_AnnDrankDrug_Relation_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnKiss2);
    await ann.setQuestion(new Question({ text: `Don't you like me?`, key: `v4ToldNaturalDrunkAnnYouLikeHer` })
        .option({ title: `I do, but you are drunk`, key: true })
        .option({ title: `I don't`, key: false }));


    if (Question.globalAnswers.v4ToldNaturalDrunkAnnYouLikeHer) {
        await mc.set((properties) => {
            properties.annLateGF = true;
            properties.annStatus = "gf";
        });
        mc.talk(`I do, but you are drunk.`);
        ann.talk(`Who cares?!`);
        ImageClass.setImage(images.v4.BarAnnKiss2);
        mc.talk(`Ann, we should do it once you are sober.`);
        ann.talk(`Kiss me already!`);
        mc.talk(`Stop it Ann.`);
    } else {
        await mc.set((properties) => {
            properties.annLateGF = false;
            properties.annLateHate = true;
            properties.annStatus = "hate";

        });
        await ann.set((properties) => {
            properties.isCorrupted = true;
        });
        ImageClass.setImage(images.v4.BarAnnKiss2);
        mc.talk(`I don't, we are just friends.`);
        ann.talk(`I don't care.`);
        ann.talk(`Just kiss me already.`);
        mc.talk(`Stop it Ann.`);
    }
    return jump(ClubEventJoeInsideAnnAloneStatus0_Continue, "ClubEventJoeInsideAnnAloneStatus0_Continue");
};

export const ClubEventJoeInsideAnnAloneStatus0_AnnDidntDrinkDrug_Question = async (): Promise<any> => {
    if (ann.properties.v4JoeyBirthdayDrinksNum > 1) {
        if (mc.properties.joeStatus === "enemy") {
            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks);

        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
        }

    } else {
        if (mc.properties.joeStatus === "enemy") {
            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks2);

        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        }

    }
    await ann.setQuestion(new Question({ text: `As more than a friend...`, key: `v4ToldNaturalAnnYouLikeHer` })
        .option({ title: `I like you`, key: true })
        .option({ title: `I don't`, key: false }));


    if (Question.globalAnswers.v4ToldNaturalAnnYouLikeHer) {
        await mc.set((properties) => {
            properties.annLateGF = true;
            properties.annStatus = "gf";
            properties.annLateHate = false;
        });
        mc.talk(`I like you.`);
        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks_Happy);
        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        }
        ann.talk(`Oh really? Hehe.`);
        if (Question.globalAnswers.v4WithoutJoeyLiedToAnn === false) {

            ann.talk(`I am so happy to hear that because I feel the same way.`);
        }

    } else {
        await mc.set((properties) => {
            properties.annStatus = "hate";
            properties.annLateGF = false;
            properties.annLateHate = true;
        });
        await ann.set((properties) => {
            properties.isCorrupted = true;
        });
        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks_Sad);
        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan4_Sad);
        }
        mc.talk(`I think we should just stay friends.`);
        ann.talk(`Oh...`);
        ann.talk(`Fine.`);
        mc.talk(`Don't be angry.`);
        ann.talk(`I'm not angry, I'm just disappointed...`);
    }
    return jump(ClubEventJoeInsideAnnAloneStatus0_Continue, "ClubEventJoeInsideAnnAloneStatus0_Continue");
};


export const ClubEventJoeInsideAnnAloneStatus0_Continue = async (): Promise<any> => {

    if (mc.properties.joeStatus === "enemy") {

        return jump(ClubEventWithoutJoeInsideGoToVanessa, "ClubEventWithoutJoeInsideGoToVanessa");
    }
    return jump(ClubEventJoeInsideAnnAloneChris, "ClubEventJoeInsideAnnAloneChris");
};

export const ClubEventJoeInsideAnnAloneStatus1 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
    await ann.setQuestion(new Question({ text: `Let's talk about something else.`, key: `v4AnnHateTalkAboutSomethingElse` })
        .option({ title: `I saw you with Vanessa`, key: `sawYouWithVanessa` })
        .option({ title: `Chit chat`, key: `chitChat` }));

    if (Question.globalAnswers.v4AnnHateTalkAboutSomethingElse === "sawYouWithVanessa") {
        mc.talk(`I saw you with Vanessa.`);
        ann.talk(`What do you mean? When?`);
        mc.talk(`When you went to the restroom.`);
        ann.talk(`Were you spying on us?`);
        if (mc.properties.liar > 1) {
            mc.talk(`No, I was there by chance.`);

        } else {

            mc.talk(`Yes.`);
        }

        ann.talk(`And?`);
        mc.talk(`I know you took that pill.`);
        ann.talk(`Hehe, I am in a good mood, don't try to ruin it for me.`);
        mc.think(`I need to talk to her once she is sober, she is not like herself right now.`);
    } else {
        mc.talk(`Do you know what college you want to get into?`);
        ann.talk(`To be honest, I stopped thinking about that...`);
        mc.talk(`Why?`);
        ann.talk(`I don't know, it doesn't seem as important as before.`);
        ann.talk(`I still try to study, but my mind is in a different place.`);
        mc.talk(`Is it because of me?`);
        ann.talk(`Nooo.`);
    }
    ann.talk(`I like this feeling.`);
    ann.talk(`Now, I can understand why people drink.`);
    ann.talk(`Suddenly I want to dance and do things I never do.`);
    ann.talk(`But I am not drunk!!!`);
    ann.talk(`I still know what I am doing!`);
    return jump(ClubEventJoeInsideAnnAloneChris, "ClubEventJoeInsideAnnAloneChris");
};

export const ClubEventJoeInsideAnnAloneStatus23 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
    if (ann.properties.v4JoeyBirthdayDrinksNum > 1) {
        ann.talk(`I am starting to feel dizzy.`);
        ann.talk(`I don't want to be an alcoholic.`);
        mc.talk(`Haha, you are far away from that, trust me.`);
        ann.talk(`How do you know? Are you one?`);
        ann.talk(`The drinks don't seem to affect you...`);
        mc.talk(`It's all about endurance, I used to drink a lot with Joey.`);
        ann.talk(`Oh... Ok.`);
        ann.talk(`Anyway, I'm happy.`);
        mc.talk(`Happy?`);
        ann.talk(`Yes.`);
    } else {

        ann.talk(`I'm happy.`);
    }
    ann.talk(`Happy, being here, with you.`);
    ann.talk(`Just a few hours ago we were in your room... On your bed.`);
    ann.talk(`Hehehe.`);
    ann.talk(`I like that feeling.`);
    if (ann.properties.v4JoeyBirthdayDrinksNum > 2) {
        ImageClass.setImage(images.v4.BarAnnAloneNoVan2);

    } else {

        ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
    }


    mc.talk(`Me too.`);

    if (ann.properties.v4JoeyBirthdayDrinksNum > 2) {
        mc.think(`She looks a bit tipsy.`);

    }


    ann.talk(`I liked seeing the look on your face when I touched you.`);
    if (mc.properties.alpha > 5) {
        mc.talk(`I'm glad you liked it but I expected a blowjob.`);
        ann.talk(`I know... Maybe next time...`);
        mc.talk(`Maybe?`);
        ann.talk(`I'll try I promise.`);
        mc.talk(`I trust you, don't let me down.`);
    } else {

        mc.talk(`I enjoyed it.`);
    }
    await mc.setQuestion(new Question({ text: `Great!\nHehe.`, key: `v4BarAnnGFToldHerToDrinkMore` })
        .option({ title: `You should drink more`, key: true })
        .option({ title: `Say nothing`, key: false }));


    if (Question.globalAnswers.v4BarAnnGFToldHerToDrinkMore) {
        await ann.set((properties) => {
            properties.v4JoeyBirthdayDrinksNum++;
        });
        mc.talk(`You should drink more.`);
        ann.talk(`You really think so?`);
        mc.talk(`Yes, you are cute when you drink.`);

        mc.talk(`There are still drinks left.`);
        ann.talk(`I'll throw up!`);
        mc.talk(`You won't.`);
        ann.talk(`Ok, I trust you!`);
        mc.talk(`Cheers!`);
        ImageClass.setImage(images.v4.BarAnnAloneNoVan3, { wait: 2 });
    }

    return jump(ClubEventJoeInsideAnnAloneChris, "ClubEventJoeInsideAnnAloneChris");
};

export const ClubEventJoeInsideAnnAloneChris = async (): Promise<any> => {
    if (Question.globalAnswers.v25JoeTODAgree ||
        Question.globalAnswers.v1AllowChrisGetAnnsNumber ||
        mc.properties.annStatus === "hate") {
        return jump(ClubEventJoeInsideAnnAloneChrisTODAgree, "ClubEventJoeInsideAnnAloneChrisTODAgree");

    }
    return jump(ClubEventJoeInsideAnnAloneChrisNotTodAgree, "ClubEventJoeInsideAnnAloneChrisNotTodAgree");

};

export const ClubEventJoeInsideAnnAloneChrisTODAgree = async (): Promise<any> => {
    if (mc.properties.annLateHate && !ann.properties.v4DrankDrug) {
        ImageClass.setImage(images.v4.BarAnnChris2_sad);
    } else if (mc.properties.annLateHate && ann.properties.v4DrankDrug) {

        ImageClass.setImage(images.v4.BarAnnChris_sad);
    } else {
        ImageClass.setImage(images.v4.BarAnnChris);
    }

    chris.talk(`Hey guys, is everything ok?`);


    if (mc.properties.annLateHate && !ann.properties.v4DrankDrug) {

        mc.talk(`Sure, we are fine.`);
        chris.talk(`Did your friends leave already?`);
        mc.talk(`Yes, they did.`);
        chris.talk(`That's too bad.`);
    }




    if (mc.properties.annStatus === "hate" && !mc.properties.annLateHate) {
        ImageClass.setImage(images.v4.BarAnnChris);
        ann.talk(`Hey Chris, join us!`);
        chris.talk(`Well, no one has order drinks for a while so why not?`);
    } else {

        chris.talk(`My shift is almost over, I'll join you.`);
    }
    if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 1) {

        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
    } else {

        ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
    }

    if (ann.properties.v4DrankDrug && mc.properties.joeStatus !== "enemy") {

        mc.think(`Whatever Vanessa put in her drinks is starting to work... She is giggling nonstop.`);
    }

    if (ann.properties.v4DrankDrug || (mc.properties.annStatus === "hate" && !mc.properties.annLateHate)) {
        chris.talk(`How is your night going?`);
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        ann.talk(`Going great! Hehehe.`);
        chris.talk(`With that smile, you must be having fun.`);
        ann.talk(`Yeah... Hehehe.`);
        if (mc.properties.annLateHate) {
            mc.think(`She doesn't even care I turned her down a few seconds ago...`);
        }

    }

    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        return jump(ClubEventJoeInsideAnnAloneChrisTODAgreeHaveNumber, "ClubEventJoeInsideAnnAloneChrisTODAgreeHaveNumber");

    }
    return jump(ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber, "ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber");

};


export const ClubEventJoeInsideAnnAloneChrisTODAgreeHaveNumber = async (): Promise<any> => {
    if (mc.properties.annStatus === "hate") {
        chris.talk(`Ann, I'm so glad to see you again.`);

        ann.talk(`Hehe me tooo...`);

        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        chris.talk(`Ann and I, were texting for the past two days.`);
        if (Question.globalAnswers.v3KeepAnsweringChris) {
            mc.talk(`Yeah... You told us when we arrived.`);

        }
        chris.talk(`She told me you turned her down.`);
        chris.talk(`It's a real shame.`);
        chris.talk(`She is an amazing girl.`);
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        ann.talk(`He doesn't like me...`);
        chris.talk(`Don't worry I am sure you will find someone.`);
        ann.talk(`You really think so?`);
        chris.talk(`Of course.`);
        chris.talk(`You are cute, beautiful, funny and smart.`);
        ann.talk(`Hehe, thanks.`);
        chris.talk(`Take me for example.`);
        chris.talk(`I meet tons of girls every day.`);
        ann.talk(`Really? Are you that popular? Hehe.`);
        chris.talk(`I don't love talking about myself, but people say that I do.`);
        chris.talk(`And with that being said, you really caught my eye. Since I first saw you.`);
        ann.talk(`But I was here with ${mc.name}!`);
        ImageClass.setImage(images.v4.BarAnnChrisTouch);
        chris.talk(`I know, but it still didn't stop me from trying to get close to you.`);
        await mc.setQuestion(new Question({ text: `He is touching her and it doesn't seems like it bothers her.`, options: { think: true }, key: `v4AnnHateToldChrisToStopTouchingAnn` })
            .option({ title: `Tell him to stop`, key: true })
            .option({ title: `Say nothing`, key: false }));


        if (Question.globalAnswers.v4AnnHateToldChrisToStopTouchingAnn) {

            return jump(ClubEventJoeInsideAnnAloneChrisStop, "ClubEventJoeInsideAnnAloneChrisStop");
        } else {

            return jump(ClubEventJoeInsideAnnAloneChrisLet, "ClubEventJoeInsideAnnAloneChrisLet");
        }

    }
    if (mc.properties.annStatus === "gf") {
        if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
        }
        chris.talk(`Did anyone ever tell you that you two are a cute couple?`);
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        ann.talk(`Hehe, thanks.`);
        if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
        }
        chris.talk(`Before I worked here, I was working in a different bar in another town, and I saw many couples coming there so I know what I'm talking about.`);
        chris.talk(`I remember when I first saw you here you said you weren't a couple, was it your first date?`);
        mc.talk(`Yeah.`);
        chris.talk(`So it looks like things are going good for you two.`);
        if (Question.globalAnswers.v3KeepAnsweringChris) {
            chris.talk(`I don't know if Ann told you but we were texting today.`);

        }

        chris.talk(`But to tell you the truth, you were sitting here for some time now, and I haven't seen you kiss.`);
        ann.talk(`He is right ${mc.name}!`);
        ImageClass.setImage(images.v4.BarAnnKiss3);
        ann.talk(`Muah.`);
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        ann.talk(`Is that better? Hehe.`);
        if (ann.properties.v4JoeyBirthdayDrinksNum > 3) {

            ann.talk(`He is my boyfriend! I can kiss him all day long!`);
            mc.think(`She is really drunk.`);
        }
        chris.talk(`Of course, much better.`);
        chris.talk(`Hold that thought for a minute, I need to check if anyone needs some service, be right back.`);
        if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan_2);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan_2);
        }
        ann.talk(`He is cute!`);
        mc.talk(`You didn't like him so much at the start.`);
        ann.talk(`I've changed my mind, hehe.`);
        mc.talk(`Do you know what he wants from you?`);
        ann.talk(`Nooo... I know what you think.`);
        ann.talk(`Maybe he wanted to be my boyfriend at first but now he is just my friend.`);
        ann.talk(`He knows I'm with you, it doesn't make sense.`);
        mc.talk(`Are you really this naive?`);
        ann.talk(`I'm not!`);
        mc.talk(`You will see that I'm right.`);

        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        chris.talk(`Back.`);
        mc.talk(`That was fast.`);
        if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
        }
        chris.talk(`People are busy dancing so no one really needs my service right now.`);
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        ann.talk(`Chris.`);
        chris.talk(`Yes?`);
        ann.talk(`Can I ask you something?`);
        chris.talk(`Of course.`);
        ann.talk(`Why do you talk to me?`);
        chris.talk(`Because I like talking to you.`);
        chris.talk(`You are a great listener and gives really good advices.`);
        ann.talk(`Hehe, thanks.`);

        ImageClass.setImage(images.v4.BarAnnChrisTouch);

        chris.talk(`And you are really funny when you are embarrassed.`);
        ann.talk(`Hehe.`);

        return jump(ClubEventJoeInsideAnnAloneChrisTODAgreeHaveNumber23Continue, "ClubEventJoeInsideAnnAloneChrisTODAgreeHaveNumber23Continue");

    }
};

export const ClubEventJoeInsideAnnAloneChrisTODAgreeHaveNumber23Continue = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnChrisTouch);

    await mc.setQuestion(new Question({ text: `He is touching her while I'm sitting right here, I think that Ann still didn't get the message.`, key: `v4AnnGFToldChrisToStopTouchingAnn` })
        .option({ title: `Let him continue`, key: true })
        .option({ title: `Stop him`, key: false }));


    if (Question.globalAnswers.v4AnnGFToldChrisToStopTouchingAnn) {
        return jump(ClubEventJoeInsideAnnAloneChrisLet, "ClubEventJoeInsideAnnAloneChrisLet");

    } else {

        return jump(ClubEventJoeInsideAnnAloneChrisStop, "ClubEventJoeInsideAnnAloneChrisStop");
    }
};

export const ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber = async (): Promise<any> => {

    chris.talk(`Did anyone ever tell you that you two are a cute couple?`);

    if (mc.properties.annStatus === "gf") {
        return jump(ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber2To4, "ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber2To4");

    } else {
        return jump(ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber1Or5, "ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber1Or5");

    }
};

export const ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber2To4 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
    if (mc.properties.annStatus === "gf" && !mc.properties.annLateGF) {

        ann.talk(`Hehe, thanks...`);
    } else {

        ann.talk(`We aren't a couple...`);
        ann.talk(`But we might be, hehe.`);
        chris.talk(`That's cool.`);
    }
    if (ann.properties.v4JoeyBirthdayDrinksNum > 2) {

        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
    } else {

        ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
    }
    chris.talk(`So, what do you guys do for fun?`);
    if (mc.properties.annLateGF) {

        mc.talk(`We don't know each other for so long to be honest.`);
    } else {

        mc.talk(`We just started going out so nothing much...`);
    }

    chris.talk(`Oh, how did you two meet?`);
    ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
    ann.talk(`Through Vanessa.`);
    chris.talk(`Oh Vanessa, that crazy girl.`);
    if (mc.properties.annLateGF) {
        ann.talk(`Chris, can I ask you a question?`);
        chris.talk(`Of course.`);
        ann.talk(`Why did you do what you did with Vanessa?`);
        chris.talk(`You mean her sucking my dick?`);
        if (ann.properties.v4DrankDrug) {

            ann.talk(`Hehe, yes.`);
        } else {

            ann.talk(`Yeah...`);
        }

        chris.talk(`Why not? I am a guy, and she was ready and willing.`);
        chris.talk(`I bet you do that also.`);
        ann.talk(`I haven't.`);
        chris.talk(`That's too bad.`);
    } else {
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        ann.talk(`Why do you say that?`);
        chris.talk(`Can you say otherwise?`);
        ann.talk(`She has her own style... But crazy?`);
        chris.talk(`In a good way.`);

        chris.talk(`For example, I saw how she was dancing with that guy while her boyfriend was sitting right here.`);
        if (Question.globalAnswers.v4ToldJoeyToTurnAround) {
            mc.talk(`It was hard not to with all that drama on the dance floor.`);
            if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 2) {

                ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
            } else {

                ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
            }
            chris.talk(`That's right.`);
        } else {
            chris.talk(`And how they went together to the restroom.`);
            if (ann.properties.v4DrankDrug) {
                ann.talk(`Hehe, what a slut.`);

            } else {

                ann.talk(`What???`);
                ann.talk(`I know what she is like, but Joey was sitting right here!`);
                chris.talk(`I guess you don't know her well enough.`);
            }
        }

    }
    if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 2) {

        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
    } else {
        ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
    }
    chris.talk(`Well, I would love to continue talking but I need to get going.`);
    chris.talk(`Bye guys, nice talking to you.`);
    mc.talk(`Cya.`);

    return jump(ClubHome, "ClubHome");
};

export const ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber1Or5 = async (): Promise<any> => {
    if (mc.properties.joeStatus !== "enemy") {
        if (mc.properties.annLateHate) {
            ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
            ann.talk(`We aren't a couple...`);
            if (ann.properties.v4DrankDrug) {
                chris.talk(`Oh, you look like one.`);
                ann.talk(`No... Hehe.`);
                ann.talk(`I want to be, but he doesn't.`);
                mc.think(`Why is she telling him this?`);
                chris.talk(`Oh really? That's not very nice.`);
                chris.talk(`But it doesn't seem like it bothers you.`);
                ann.talk(`It does, but I can't stop smiling, hehe.`);
                ImageClass.setImage(images.v4.BarAnnChrisTouch);
                chris.talk(`That's great because you have a great smile.`);


            } else {
                ann.talk(`And actually, I'm not in the mood to stay here any longer.`);
                chris.talk(`Why? What happened?`);
                ann.talk(`Nothing important.`);
                ImageClass.setImage(images.v4.BarAnnChrisTouch);

                chris.talk(`Are you sure? I am a great listener.`);
                chris.talk(`My shift is almost over but I can stay a bit longer.`);
                ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
                ann.talk(`No... I'd rather go home.`);
                chris.talk(`Let's go. I'll give you a ride.`);
                ann.talk(`I don't really know you...`);
                chris.talk(`I'm not a stranger, I'm Vanessa's friend.`);
                ann.talk(`So I've heard...`);
                chris.talk(`So what do you say?\nLast chance.`);
                ann.talk(`Ok, let's go.`);
                ImageClass.setImage(images.v4.BarAlone, { duration: 1.5 });
                mc.think(`They left...`);
                mc.think(`Nothing left for me to do here... I'll just head home.`);
                return jump(ClubHome, "ClubHome");

            }
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
            ann.talk(`We aren't a couple...`);
            ann.talk(`Chris.`);
            chris.talk(`Yes?`);
            ann.talk(`What's like being a bartender?`);
            chris.talk(`It's cool, I can't complain.`);
            chris.talk(`I get to meet a lot of new people.`);
            ann.talk(`Really? What kind of people? Hehe.`);
            chris.talk(`All kind of people.`);
            ImageClass.setImage(images.v4.BarAnnChrisTouch);
            chris.talk(`Most are boring but sometimes I am lucky and meet someone like you.`);
            ann.talk(`Hehe.`);
        }
    }
    return jump(ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber1Or5Question, "ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber1Or5Question");
};

export const ClubEventJoeInsideAnnAloneChrisTODAgreeDoesntHaveNumber1Or5Question = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnChrisTouch);
    await mc.setQuestion(new Question({ text: `He is touching her and it doesn't seems to bothers her.`, options: { think: true }, key: `v4AnnHateStatus1ToldChrisToStopTouchingAnn` })
        .option({ title: `Tell him to stop`, key: true })
        .option({ title: `Say nothing`, key: false }));


    if (Question.globalAnswers.v4AnnHateStatus1ToldChrisToStopTouchingAnn) {
        return jump(ClubEventJoeInsideAnnAloneChrisStop, "ClubEventJoeInsideAnnAloneChrisStop");

    } else {

        return jump(ClubEventJoeInsideAnnAloneChrisLet, "ClubEventJoeInsideAnnAloneChrisLet");
    }
};

export const ClubEventJoeInsideAnnAloneChrisLet = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnChrisTouch);
    if (mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v4.BarAnnChrisTouch);
        ann.talk(`Hehehe. That tickles.`);
        ImageClass.setImage(images.v4.BarAnnChrisKiss);
        ann.talk(`Mmm...`);
        mc.think(`Both of them don't care that I'm sitting right here.`);

        mc.think(`Vanessa's magic pill boosted Ann's confidence.`);
        mc.think(`I bet she would have rejected him if she didn't take it.`);
        ImageClass.setImage(images.v4.BarAnnChrisTouch);
        chris.talk(`I need some fresh air, join me.`);
        ann.talk(`Ok.`);
        return jump(ClubEventJoeInsideAnnAloneChrisLet1Left, "ClubEventJoeInsideAnnAloneChrisLet1Left");
    } else {

        ImageClass.setImage(images.v4.BarAnnChrisTouch);


        ann.talk(`${mc.name} said that you might want more from me.`);
        chris.talk(`What if I do?`);
        if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
        }

        ann.talk(`OH!`);
        ann.talk(`I am naive!`);
        ImageClass.setImage(images.v4.BarAnnChrisTouch);
        chris.talk(`Ann.`);
        ImageClass.setImage(images.v4.BarAnnChrisTouchCloser);
        chris.talk(`Relax.`);
        if (ann.properties.v4JoeyBirthdayDrinksNum < 3) {
            ann.talk(`No... I'd rather not.`);
            ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
            chris.talk(`That's too bad.`);

            if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

                ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
            } else {

                ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
            }


            chris.talk(`Anyway, I'll get back to work.`);
            if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 2) {

                ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan_2_surprised);
            } else {

                ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan_2_surprised);
            }
            ann.talk(`You were right!`);
            ann.talk(`I think he tried to kiss me!`);
            mc.talk(`You see.`);
            ann.talk(`I must have misunderstood him.`);
            mc.talk(`Does it change anything?`);
            ann.talk(`I still like him... But now I know his true intentions.`);
            ann.talk(`Can we forget this happened and just enjoy the rest of the evening?`);
            mc.talk(`Of course.`);

        } else {
            ImageClass.setImage(images.v4.BarAnnChrisKiss, { wait: true });
            ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
            ann.talk(`Oh.`);
            if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

                ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
            } else {

                ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
            }
            chris.talk(`I'll leave you alone now.`);
            ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
            mc.talk(`He threw a bomb and left.`);
            ann.talk(`Oh my God! You were right.`);
            mc.talk(`I told you.`);
            ann.talk(`What am I suppose to do now?`);
            mc.talk(`That's for you to decide.`);
            if (Question.globalAnswers.todAnnAsksWhyKissJoe === "IlikeSeeingYouWithOthers") {
                ann.talk(`Yesterday you said that you like seeing me with other people.`);
                if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {

                    ann.talk(`So you got it! Hehe.`);
                } else {

                    ann.talk(`But it think I'll need to get used to it...`);
                }
            } else {

                ann.talk(`How come you aren't mad?`);
                mc.talk(`I could have stopped him but I chose not to.`);
                mc.talk(`I guess he noticed it, that's why he continued.`);
                ann.talk(`Oh.`);
            }


            if (ann.properties.v4JoeyBirthdayDrinksNum !== 3) {

                ann.talk(`I guess that's behind us now...`);
            }
        }

    }

    return jump(ClubHome, "ClubHome");
};

export const ClubEventJoeInsideAnnAloneChrisLet1Left = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAlone);
    mc.think(`So, Joe and Vanessa left earlier.`);
    mc.think(`Ann went with Chris outside.`);
    await mc.setQuestion(new Question({ text: `And I'm sitting here alone.`, options: { think: true }, key: `v4BarWentToLookForAnnChris` })
        .option({ title: `Look for Ann and Chris`, key: true })
        .option({ title: `Go home`, key: false }));


    if (Question.globalAnswers.v4BarWentToLookForAnnChris) {
        mc.think(`Sneaking up on Ann is becoming my routine.\nBut who cares?`);
        return jump(ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar, "ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar");
    } else {
        return jump(ClubHome, "ClubHome");
    }
};


export const ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar = async (): Promise<any> => {
    doWaitImageByTime(images.v4.Car1, { transition: true });
    if (!Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJLeave`)) {

        mc.think(`There is no one here except for this car.`);
    }
    ImageClass.setImage(images.v4.Car2);
    if (mc.properties.annLateHate) {
        if (!Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJLeave`)) {
            if (mc.properties.joeStatus === "enemy") {

            } else {

                mc.think(`There is Chris.`);
                mc.think(`But where is Ann?`);
            }


        }

        if (Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJLeave`) || Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJStay`)) {
            mc.think(`What Chris is doing here?`);
            mc.think(`He was with Ann before I left.`);
        }

    } else {

        mc.think(`I can see Chris but where is Ann?`);
    }
    mc.think(`Don't tell me she is...`);
    ImageClass.setImage(images.v4.Car3, { duration: 0.6 });
    ann.talk(`It's my first time doing this.`);
    mc.think(`It's quiet outside and the windows are open, I can hear everything.`);
    ann.talk(`Don't think that I am cheap.`);
    chris.talk(`I don't think that you are cheap.`);
    ImageClass.setImage(images.v4.Car4);
    chris.talk(`But we'll talk about that later.`);
    ImageClass.setImage(images.v4.Car2);
    if (mc.properties.annLateHate) {
        if (mc.properties.agreeToChrisProposal === undefined) {
            if (Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJLeave`)) {

                mc.think(`What the fuck?`);
                mc.think(`Am I going to see girls sucking dick all day?`);
            } else {
                mc.think(`This fucking asshole.`);
                if (mc.properties.joeStatus === "enemy") {

                    mc.think(`I think that I hurt Ann too much, and with the mix of the alcohol, she was easy prey.`);
                    mc.think(`She did look drunk for most of the night...`);
                } else if (ann.properties.v4DrankDrug) {
                    mc.think(`I think that I hurt Ann too much, and with the mix of the alcohol and that pill, she was easy prey.`);

                }

            }
        } else if (mc.properties.agreeToChrisProposal) {
            mc.think(`I agreed to share my girls with him but I didn't think he would do this that quick.`);
            mc.think(`And Ann isn't really my girl... I just turned her down.`);
        } else {
            mc.think(`This fucking asshole.`);
            mc.think(`I told him I don't want to share my girls with him.`);
            mc.think(`But Ann isn't really my girl... I just turned her down.`);
        }
    } else {

    }
    await mc.set((properties) => {
        properties.v4SawAnnBJChrisInCar = true;
    });
    chris.talk(`Yes, keep going.`);
    chris.talk(`Open your mouth.`);
    chris.talk(`Wider.`);
    chris.talk(`More.`);
    chris.talk(`Fuckkk.`);
    mc.think(`She is starting to act like Vanessa.`);
    mc.think(`Is it my fault?`);
    mc.think(`I could have gotten a blowjob, but instead, I'm spying on people.`);
    mc.think(`I've seen enough.`);
    mc.think(`Time to go home.`);

    return jump(ClubHome, "ClubHome");
};

export const ClubEventJoeInsideAnnAloneChrisStop = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnChrisTouch);
    mc.talk(`Chris that's enough.`);
    if (mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        chris.talk(`Hey dude, you had your chance.`);
        ann.talk(`Chris is right! Hehe.`);
        mc.talk(`I still don't think you should touch her like that.`);
        ImageClass.setImage(images.v4.BarAnnChrisClose2_NoVan);
        chris.talk(`Does it bother you?`);
        ann.talk(`No.`);
        chris.talk(`Let's go somewhere quiet.`);
        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        ann.talk(`Bye, ${mc.name}, is was fun hehe.`);
        return jump(ClubEventJoeInsideAnnAloneChrisLet1Left, "ClubEventJoeInsideAnnAloneChrisLet1Left");
    } else {
        if (ann.properties.v4DrankDrug || ann.properties.v4JoeyBirthdayDrinksNum > 2) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
        } else {
            ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);

        }

        chris.talk(`You are right, I'm sorry.`);
        chris.talk(`I'll give you guys some space.`);
        if (ann.properties.v4JoeyBirthdayDrinksNum === 3) {
            ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
            ann.talk(`Hehe, he is nice.`);
            if (Question.globalAnswers.v3KeepAnsweringChris) {

                ann.talk(`We text all the time.`);
            } else {
                ann.talk(`He keeps texting me but I keep ignoring him hehe.`);
            }

            ann.talk(`But I like you more!`);
        } else {

            ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
            ann.talk(`Did he make you feel uncomfortable?`);
            mc.talk(`I guess.`);
            if (Question.globalAnswers.v3KeepAnsweringChris) {

                ann.talk(`You told me to talk to him on the phone and we became good friends now...`);
                mc.talk(`Yeah, I understand.`);
                mc.talk(`We'll see what happens.`);
            } else {

                ann.talk(`I didn't answer him, just like you said.`);
            }

        }

    }

    return jump(ClubHome, "ClubHome");

};

export const ClubEventJoeInsideAnnAloneChrisNotTodAgree = async (): Promise<any> => {
    return jump(ClubHome, "ClubHome");
};


